import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import _promise_polyfill from 'promise-polyfill';
import _event_source_polyfill from 'event-source-polyfill';
// import async from 'async';
import Api from '@/lib/api/api';
import session from '@/models/v5/session';
import InvalidSessionDialog from '@/views/dialogs/invalid_session';
import AlertView from '@/views/alert_view';
import ResponseResultsView from '@/views/response_results_view';
import DialogInterface from '@/interfaces/dialog';
import TopNavView from '@/views/top_nav';
import init_api from '@/inits/api';
import init_jquery from '@/inits/jquery';
import init_xhr_redirects from '@/inits/xhr_redirects';
import init_session_id from '@/inits/session_id';
import init_cloud_config from '@/inits/cloud_config';
import init_global_collections from '@/inits/global_collections';
import init_editor_settings from '@/inits/editor_settings';
import init_recent_revisions from '@/inits/recent_revisions';
import init_router from '@/inits/router';
import init_html from '@/inits/html';
import init_layouts from '@/inits/layouts';
import init_web_sockets from '@/inits/web_sockets';
import init_handlebars from '@/inits/handlebars';
import init_status_notification from '@/inits/status_notification';
import init_ide_settings from '@/inits/ide_settings';
import init_selection from '@/inits/selection';
import controller from '@/controller';
import BreadcrumbNavLayout from '@/views/breadcrumb_nav_layout';

// Initialize the App
var globalCh = Radio.channel('global');
var apiCh = Api.getChannel();

// Make controller availabel on the global channel
globalCh.reply('controller', function() { return controller; });

// Make controller commands available on the globalCh
globalCh.reply(controller);

// List of initializers.
// Order might matter here. Some initializers may be making assumptions
// about what has been loaded before. This should probably be fixed and
// initializers making assumptions should check before acting on them.
var initializers = [
    // It seems this init is unnecessary since it happens in ide.js
    // TODO: is the dichotomy between ide.js and ide_app.js even necessary?
    init_jquery,
    init_xhr_redirects,
    init_session_id,

    init_global_collections,
    init_status_notification,
    init_ide_settings,
    init_editor_settings,
    init_recent_revisions,

    init_router,
    init_html,
    init_layouts,

    init_web_sockets,
    init_handlebars,
    init_selection
]; // END initializers

function start(app) {
    var options = app.options;
    initializers.push(init_session_and_render_app);
    init_api.call(this, options);
    function run_inits() {
        for (var i = 0; i < initializers.length; i++) {
            initializers[i].call(app, options);
        }
    }
    return init_cloud_config.call(this, options).always(run_inits);
}
function init_session_and_render_app(options) {
    /*
        * Allows QA to print app options
        * for debugging & sanity
    */
    var qa_channel = Radio.channel('qa');

    qa_channel.reply('print_options', function(){
        console.log(JSON.stringify(options, null, 4));
    });

    /*
        * Make app initialization options available on the global channel
        * if no option passed
        *   return options
        * if option is a key of options
        *   return it's value
        * if options is child key that causes of the keys to evaluate to true
        *   return true
        * else undefined
        */

    globalCh.reply('app_options', function(option) {
        if ( !option ) {
            return options;
        }
        if ( option && _.has(options, option) ){
            return options[option];
        }
        if ( option && _.findKey(options, option) ){
            return options[_.findKey(options, option)][option];
        }
    });

    // Don't bother trying to fetch the session if the user has no token, or if the token is expired
    var bad_api_or_token = !(options.api && session.is_valid());
    if (bad_api_or_token) {
        return sessionFetchError.call(this, options);
    }

    var accounts = apiCh.request('account');
    session.refresh_token().always(function(r){
        accounts.me({
            success: function(account) {
                return account.fetch_permissions_for_account(account).done(()=>{
                    successfulSessionFetch();
                });
            },
            error: function(coll, resp) {
                sessionFetchError.call(this, options);
                return resp;
            }
        });
    })
    .done(render_app_layout());
}
function hide_loading_screen() {
    // Hide the loading screen (after 0.1s to ensure the progress bar finishes transition)
    setTimeout(function() {
        var loading_container = $('#loading-container');
        // Opacity has a 0.5s ease transition
        loading_container.css('opacity', 0);
        // There's an event fired when the transition finishes, but it looks cumbersome to use
        // so imma set another timeout here...
        setTimeout(function() {
            loading_container.hide();
        }, 550);

    }, 100);
}
function getNewSession(){
    // Clear all in-memory and stored session values (tokens, etc)
    session.reset();
    if (Backbone.history.location.pathname.indexOf('login') === -1) {
        Backbone.history.start({pushState: true, root: '/', silent: true});
        globalCh.request('login');
    } else {
        Backbone.history.start({pushState: true, root: '/'});
    }
    hide_loading_screen();
}
function sessionFetchError(options) {
    session.refresh_token().then(function(){
        init_session_and_render_app.call(this, options);
    }).fail(getNewSession);
}

// Track wether the InvalidSessionDialog has been invoked or not.
// If so, don't allow it to appear again
let invalid_session = false;
// validSession is also handled at inits/web_sockets
apiCh.on('validSession', function() {
    invalid_session = false;
});

// Start function assumes all initializers have run.
// the 'this' var is the app in this context. References
// to this.thingie assumes thingie has been initialized in
// one of the init scripts above.
function successfulSessionFetch() {
    // On invalid session event, clear auth token and show dialog
    apiCh.on('invalidSession', function() {
        if (invalid_session === false) {
            invalid_session = true;
            globalCh.request('showDialog', new InvalidSessionDialog());
        }
    });
    apiCh.trigger('validSession');

    // Render the main application layouts

    function data_loaded_callback(err) {
        var app_layout = globalCh.request('app_layout');

        if (err) {
            Radio.request(
                'alerts',
                'showAlert', {
                    message: "There was an error loading data",
                    messageType: 'danger'
                }
            );
        }

        globalCh.request('create_combined_devices');

        // Show the top nav, account nav, popup manager, and production log view
        app_layout.showChildView('top_nav', new TopNavView());
        app_layout.showChildView('main_nav', new BreadcrumbNavLayout() );

        Backbone.history.start({pushState: true, root: '/'});

        hide_loading_screen();
    }
    globalCh.request('app_load_progress_fetch', data_loaded_callback);
}
function render_app_layout() {
    var app_layout = globalCh.request('app_layout');
    app_layout.render();
}

// Handlers for alert messages
var alertChannel = Radio.channel('alerts');
alertChannel.reply('showAlert', function(alert) {
    var app_layout = globalCh.request('app_layout');
    var rgn = app_layout.getRegion('alerts');
    if (!rgn) return;
    rgn.show(new AlertView(alert));
});
alertChannel.reply('hideAlert', function() {
    var app_layout = globalCh.request('app_layout');
    var rgn = app_layout.getRegion('alerts');
    if (!rgn) return;
    rgn.empty();
});
alertChannel.reply('response_dialog', function(resp, messageType, title, message) {
    var response_dialog = ResponseResultsView.extend(DialogInterface).extend({
        initialize: function(){
            this.destroyOnClose();
        }
    });
    globalCh.request('showDialog', new response_dialog({ resp: resp, messageType: 'danger', title: title, message: message }));
});

var IdeApp = Marionette.Application.extend({
    initialize: function() {
        var app = this;
        // Make the app available on the global channel
        globalCh.reply('app', function() { return app; });
        // kill the imp.token cookie if there
        session.unset_cookie();
    },
    onStart: start
});
export default IdeApp;
